<template>
    <v-app>
        <notifications position="top right" width="400px" classes="vue-notification" :duration="duration" />
        <transition mode="out-in">
            <router-view></router-view>
        </transition>
    </v-app>
</template>

<script>
export default {
    name: 'App',
    data: () => ({
        duration: 5000
    }),
};
</script>

<style lang="scss">
body {
    background-color: #f5f5f5
}

.vue-notification {
    margin: 0 5px 5px;
    padding: 10px;
    font-size: 15px !important;
    color: #ffffff;

    background-color: #44A4FC;
    border-left: 5px solid #187FE7;
    &.success {
        background: #68CD86;
        border-left-color: #42A85F;
    }

    &.warn {
        background: #ffb648;
        border-left-color: #f48a06;
    }

    &.error {
        background: #E54D42;
        border-left-color: #B82E24;
    }
}
</style>
